import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { CampaignService } from '../services/campaign/campaign.service';
import { ITEM_DISPLAY_VIEW } from '../enums/item-status-type.enum';

export const CampaignRedirectionResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const campaignService = inject(CampaignService);
  const router = inject(Router);

  const communityId = route.paramMap.get('id');
  const campaignId = route.paramMap.get('campaignId');
  const itemId = route.queryParamMap.get('logId');
  if(!itemId || !campaignId) {
    return true;
  }
  return campaignService.getCampaignById(+campaignId).pipe(
    map((response) => {
      if(response){
    if (response.isMapViewEnabled) {
      router.navigate([`/community/${communityId}/campaign/${campaignId}/map`], { queryParams: { logId: itemId } });
    } else {
        router.navigate([`/community/${communityId}/campaign/${campaignId}/gallery`], { queryParams: { logId: itemId } });
    }
      }
      return false;
    }),
    catchError((res) => {
      return of(true);
    })
  )
 
};